import React from "react";
import * as R from "ramda";
import { Query } from "react-apollo";
import { css } from "styled-components";
import { Modal, Upload, Icon, notification, Dropdown, Menu } from "antd";
import { Link } from "react-router-dom";
import gql from "graphql-tag";

import { withApolloState } from "@arachnys/flow-app/src/util/apollo";
import { transformBulkUploadFile, xlsxType } from "@arachnys/flow-app/src/util";
import WithAuth from "../../container/WithAuth";
import { ActionButton } from "./ActionMenu";

const styles = {
    buttonContainer: css`
        display: inline-block;
    `,
};

const uploadResultNotify = result => {
    const { status } = result.file;
    if (status === "error") {
        const errorId = R.pathOr("", ["file", "response", "data"], result);

        switch (errorId) {
            case "file_not_found":
                notification.error({
                    message: "No file attached",
                    description: "Please attach .csv or .xlsx file.",
                });
                break;
            case "wrong_file_type":
                notification.error({
                    message: "Incorrect file format",
                    description:
                        "File upload failed. Please check the file format and try again.",
                });
                break;
            case "header_error":
                notification.error({
                    message: "Incorrect file format",
                    description:
                        "File upload failed. Please check the column headers in the file and try again.",
                });
                break;
            default:
                notification.error({
                    message: "File upload error",
                    description:
                        "We've been unable to upload the file at this time. Please check your internet connection and try again later.",
                });
        }
    } else if (status === "done") {
        notification.info({
            message: "File uploaded",
            description:
                "The file has been uploaded and will be processed in the background.",
        });
    }
};

const Uploader = ({ showBulkAction, auth, toggleBulkAction, title, url }) => (
    <Modal
        key={title}
        onCancel={toggleBulkAction(false)}
        title={title}
        footer=""
        visible={showBulkAction}
    >
        <Upload.Dragger
            accept={`.csv,text/csv,.xlsx,${xlsxType}`}
            action={url}
            auth={auth}
            headers={{
                authorization: "Bearer " + auth.accessToken,
            }}
            transformFile={transformBulkUploadFile}
            onChange={result => {
                const status = result.file.status;
                if (
                    showBulkAction &&
                    !["uploading", "removed"].includes(status)
                ) {
                    toggleBulkAction(false)(() => uploadResultNotify(result));
                }
            }}
        >
            <p className="ant-upload-drag-icon">
                <Icon type="inbox" />
            </p>
            <p className="ant-upload-text">
                Click or drag file to this area to upload
            </p>
            <p className="ant-upload-hint">
                {"Valid file formats：.csv, .xlsx"}
            </p>
        </Upload.Dragger>
    </Modal>
);

const BulkActionsUploaderModal = WithAuth(Uploader);

const menu = (
    terminateAction,
    newEntitiesAction,
    showTermination,
    showNewEntity
) => (
    <Menu>
        {showNewEntity && (
            <Menu.Item>
                <a onClick={newEntitiesAction}>Create New Entities</a>
            </Menu.Item>
        )}
        {showTermination && (
            <Menu.Item>
                <a onClick={terminateAction}>Terminate LoBs</a>
            </Menu.Item>
        )}
        <Menu.Item>
            <Link to="/uploads-history">Uploads History</Link>
        </Menu.Item>
    </Menu>
);

export class BulkActionsButton extends React.Component {
    state = {
        showTerminationModal: false,
        showNewEntityModal: false,
    };

    toggleBulkTermination = state => fn => {
        this.setState(
            {
                showTerminationModal: state,
                showNewEntityModal: state
                    ? false
                    : this.state.showNewEntityModal,
            },
            typeof fn === "function" ? fn : null
        );
    };

    toggleBulkNewEntities = state => fn => {
        this.setState(
            {
                showTerminationModal: state
                    ? false
                    : this.state.showTerminationModal,
                showNewEntityModal: state,
            },
            typeof fn === "function" ? fn : null
        );
    };

    render() {
        return (
            <Query
                query={gql`
                    query UploadPermissionsQuery {
                        permissions {
                            bulkTermination
                            bulkUploadBis
                        }
                    }
                `}
                fetchPolicy="network-only"
            >
                {withApolloState(({ data }) => (
                    <>
                        <Dropdown
                            overlay={menu(
                                this.toggleBulkTermination(true),
                                this.toggleBulkNewEntities(true),
                                data.permissions.bulkTermination,
                                data.permissions.bulkUploadBis
                            )}
                        >
                            <span css={styles.buttonContainer}>
                                <ActionButton
                                    icon="upload"
                                    label="Bulk Actions"
                                />
                            </span>
                        </Dropdown>
                        <BulkActionsUploaderModal
                            showBulkAction={this.state.showTerminationModal}
                            toggleBulkAction={this.toggleBulkTermination}
                            title="Bulk termination"
                            url="/lines_of_business/bulk_termination/"
                        />
                        <BulkActionsUploaderModal
                            showBulkAction={this.state.showNewEntityModal}
                            toggleBulkAction={this.toggleBulkNewEntities}
                            title="New Entities Bulk Upload"
                            url="/bulkupload/create/"
                        />
                    </>
                ))}
            </Query>
        );
    }
}
